module.exports = __webpack_public_path__ + "static/media/tacos2.99e6737a.png";